import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AiMyprDialog',
  props: {
    visible: { type: Boolean }
  },
  emits: ["update:visible", "input", "before-close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', value: boolean): void
  (e: 'input', value: boolean): void
  (e: 'before-close'): void
}), expose: any, slots: any, attrs: any }) {

/**
 * 書式編集の AI mypr ダイアログ殻（VFM）。
 * 開閉は親の `visible`（`:visible` + `@update:visible`）。中身は親の slot。
 * 遠い close は親の useAiMyprDialogControls が mitt HIDE を購読する。
 * 注: Vue 2 ESLint（valid-v-model）が `v-model:arg` を拒否するため、明示バインドを使う。
 *
 * 配置: PC 中央 / sm ボトムシート（旧 vue-js-modal + ai-mypr-modal-sheet 相当）。
 * VFM では :styles flex を使わず __container で制御する。
 */




function onInput(value: boolean) {
  emit('update:visible', value)
  emit('input', value)
  if (!value) emit('before-close')
}

function onBeforeClose() {
  emit('before-close')
}

return { __sfc: true,emit, onInput, onBeforeClose }
}

})